// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"3f791715","136":"6fc507a7","160":"bd44ab4e","208":"6aa33297","293":"27282c8e","516":"2b300f6d","519":"f608ecff","736":"f5e90768","917":"73912102","946":"a2a58ca3"}[chunkId] + ".chunk.js";
};